import React from 'react';
import { useAccountsList } from '../hooks/use-accounts-list.js';
import AccountsPageView from './accounts-page-view.jsx';

function AccountsPageContainer() {
  const state = useAccountsList();
  return <AccountsPageView {...state} />;
}

export default AccountsPageContainer;

